export const freeCursor = () => {
    setTimeout(
        () => {
            document.exitPointerLock();
        }, 1000);
}

export const BASE = `${process.env.PUBLIC_URL}`